// Stripe Configuration
export const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/14A14g4MhdJe2kx5YDfEk00';

// Replace with your actual Stripe payment link
// Example: 'https://buy.stripe.com/test_xxxxxxxxxxxxx'
